// Firefox has a few issues where stopPropagation cancels the
// focus event too early (see #1 below) and if position or float is set
// click does not fire (see #2 below).
// See VSTS: https://office.visualstudio.com/OC/_workitems/edit/2460803
// 1a: https://github.com/facebook/react/issues/8642
// 1b: https://github.com/facebook/react/issues/10232
// 1c: https://bugzilla.mozilla.org/show_bug.cgi?id=509684
// 2: https://bugzilla.mozilla.org/show_bug.cgi?id=764589
export const doNotAllowFocusEventToPropagate =
  window.navigator.userAgent.indexOf("Firefox") < 0;
